import { render, staticRenderFns } from "./accounts_dashboard.vue?vue&type=template&id=08e8cf68&"
import script from "./accounts_dashboard.vue?vue&type=script&lang=js&"
export * from "./accounts_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports